// QualityCheckLog.jsx
import React, { useState } from 'react';
import { ReactComponent as Calendar } from 'src/Images/icons/common/calendar.svg';
import getColorCode from 'src/utils/GetThemeColor';
import { Drawer } from '@mui/material';
import QualityCheckLogDetail from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckDrawers/QualityCheckLogDetail';

const STATUS_CLASS = {
  1: 'pill pill--pending',
  2: 'pill pill--pending',
  3: 'pill pill--success',
  4: 'pill pill--reject',
};

function productSummary(items, max = 4) {
  if (!items?.length) return '-';
  const head = items.slice(0, max).join(', ');
  const more = items.length - max;
  return more > 0 ? (
    <>
      {head}, <span className="text-grey">+ {more} more</span>
    </>
  ) : (
    head
  );
}

export default function QualityCheckLog({
  themeColor,
  products,
  dateLabel,
  status,
  qualityChecklogId,
}) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <div className="quality-check-logs-line-item--grid border-top">
      <div>
        <span className="text-sm">{productSummary(products, 8)}</span>
      </div>

      <div>
        <div className="div-flex-row align-items-center cg-10">
          <Calendar className="icon-size-sm" color={getColorCode(themeColor)} />
          <span className="text-sm">{dateLabel}</span>
        </div>
      </div>

      <div className="div-flex-row align-items-center">
        <span className={`${STATUS_CLASS[status?.id] || 'pill'} text-sm`}>
          {status?.name}
        </span>
      </div>

      <div className="div-flex-row div-flex-end">
        <button
          type="button"
          onClick={() => setDrawerOpen(true)}
          className="text-blue text-sm text-semi-bold create-quality-check-log-link"
        >
          View log
        </button>
      </div>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
        }}
        ModalProps={{ keepMounted: false }}
        sx={{ zIndex: 1 }}
        PaperProps={{
          sx: { width: '65%' },
        }}
      >
        <QualityCheckLogDetail qualityChecklogId={qualityChecklogId} />
      </Drawer>
    </div>
  );
}
